import { render, staticRenderFns } from "./ed-reset-password.component.vue?vue&type=template&id=e93134cc&scoped=true&"
import script from "./ed-reset-password.component.ts?vue&type=script&lang=ts&"
export * from "./ed-reset-password.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-reset-password.component.scss?vue&type=style&index=0&id=e93134cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93134cc",
  null
  
)

export default component.exports